import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";

var ISpeedReport = /*#__PURE__*/function () {
  function ISpeedReport() {
    _classCallCheck(this, ISpeedReport);

    this._sMarks = new Map();
    this._eMarks = new Map();
  }

  _createClass(ISpeedReport, [{
    key: "timeStart",
    value: function timeStart(tag) {
      this._sMarks.set(tag, Date.now());

      return this;
    }
  }, {
    key: "timeEnd",
    value: function timeEnd(tag) {
      if (!this._sMarks.has(tag)) {
        return this;
      }

      this._eMarks.set(tag, Date.now() - this._sMarks.get(tag));

      this._sMarks.delete(tag);

      return this;
    }
  }, {
    key: "time",
    value: function time(tag, cost) {
      this._eMarks.set(tag, cost);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._sMarks.clear();

      this._eMarks.clear();
    }
  }]);

  return ISpeedReport;
}();

export { ISpeedReport as default };